(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mm-one-stop-size-guide"]) return;
  try {
    
(() => {
  "use strict";
  function init(root) {
    if (root.dataset.mmOneReady) return;
    root.dataset.mmOneReady = "true";
    const selector = root.querySelector("[data-mm-one-selector]");
    const buttons = Array.from(root.querySelectorAll("[data-mm-one-family]"));
    const panels = Array.from(root.querySelectorAll("[data-mm-one-panel]"));
    function select(family) {
      if (!panels.some(p => p.dataset.mmOnePanel === family)) return;
      buttons.forEach(b => b.setAttribute("aria-pressed",String(b.dataset.mmOneFamily === family)));
      panels.forEach(p => { p.hidden = p.dataset.mmOnePanel !== family; });
    }
    buttons.forEach((button,index) => {
      button.addEventListener("click",() => select(button.dataset.mmOneFamily));
      button.addEventListener("keydown",event => {
        let next;
        if(event.key === "ArrowRight") next = (index + 1) % buttons.length;
        if(event.key === "ArrowLeft") next = (index - 1 + buttons.length) % buttons.length;
        if(event.key === "Home") next = 0;
        if(event.key === "End") next = buttons.length - 1;
        if(next === undefined) return;
        event.preventDefault();
        buttons[next].focus();
        select(buttons[next].dataset.mmOneFamily);
      });
    });
    if(selector && buttons.length && panels.length){ select("B"); selector.hidden = false; }
    function revealHash() {
      const panel = panels.find(p => "#" + p.id === window.location.hash);
      if (!panel) return;
      select(panel.dataset.mmOnePanel);
      requestAnimationFrame(() => panel.scrollIntoView({ block: "start" }));
    }
    root.querySelectorAll("[data-mm-one-select-link]").forEach(link => {
      link.addEventListener("click", event => {
        if(event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const panel = panels.find(p => p.dataset.mmOnePanel === link.dataset.mmOneSelectLink);
        if (!panel) return;
        event.preventDefault();
        event.stopPropagation();
        select(panel.dataset.mmOnePanel);
        history.pushState(null, "", "#" + panel.id);
        panel.scrollIntoView({ block: "start" });
        const heading = panel.querySelector("h3");
        if (heading) { heading.setAttribute("tabindex", "-1"); heading.focus({ preventScroll: true }); }
      });
    });
    window.addEventListener("hashchange", revealHash);
    revealHash();

    root.querySelectorAll('[data-mm-one-video]').forEach(link => {
      link.addEventListener('click', event => {
        const id = link.dataset.mmOneVideo;
        if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
        event.preventDefault();
        const frame = document.createElement('iframe');
        frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
        frame.title = link.getAttribute('aria-label');
        frame.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        link.replaceWith(frame);
        frame.focus();
      });
    });

    const dialog = root.querySelector("[data-mm-one-dialog]");
    const zoomImage = root.querySelector("[data-mm-one-zoom-image]");
    let opener;
    if(dialog && zoomImage && typeof dialog.showModal === "function"){
      root.querySelectorAll("[data-mm-one-zoom]").forEach(link => {
        link.addEventListener("click",event => {
          if(event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          const source = link.querySelector("img");
          if(!source) return;
          event.preventDefault();
          opener = link;
          zoomImage.src = link.href;
          zoomImage.alt = source.alt;
          zoomImage.width = source.width;
          zoomImage.height = source.height;
          dialog.showModal();
        });
      });
      root.querySelector("[data-mm-one-close]").addEventListener("click",() => dialog.close());
      dialog.addEventListener("click",event => {
        if(event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if(event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      });
      dialog.addEventListener("close",() => { if(opener) opener.focus(); });
    }
  }
  function scan(scope){scope.querySelectorAll("[data-mm-one-guide]").forEach(init);}
  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded",() => scan(document));
  else scan(document);
  document.addEventListener("shopify:section:load",event => scan(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
